import { Component, Inject } from '@angular/core'
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
} from '@angular/material/dialog'
import { MatCard, MatCardHeader, MatCardTitle } from '@angular/material/card'
import { MatIconModule } from '@angular/material/icon'
import { MatDivider } from '@angular/material/divider'

@Component({
  selector: 'modal-compras-historico-detail',
  imports: [MatCard, MatCardHeader, MatCardTitle, MatIconModule, MatDivider],
  templateUrl: './modal-compras-historico-detail.component.html',
  styleUrl: './modal-compras-historico-detail.component.scss',
  standalone: true,
})
export class ModalComprasHistoricoDetailComponent {
  // Toda a informação já vem na linha da listagem: o modal não chama service nenhum
  constructor(
    private dialogRef: MatDialogRef<ModalComprasHistoricoDetailComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    if (data.item) {
      this.item = data.item
    }
  }

  item: any = {}

  // Rodada sem retorno continua contando tempo, o back devolve o total até agora
  get emAberto(): boolean {
    return !this.item.dataRetorno
  }

  close() {
    this.dialogRef.close()
  }
}
